import disabled from './disabled.js';
let router = require('pjax').Router;

router.get('feature-disabled/([a-zA-Z]+)', disabled);
